// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__gb36T","buttons":"RemoveExpirationActionButtons_buttons__3z53U"};